module.exports = __webpack_public_path__ + "img/home.d3069238.svg";